/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { MarketingOptInModalResponse } from './model/marketingOptInModalResponse';

export const apiMarketingOptInRetrieve = (signal?: AbortSignal) => {
  return HTTP<MarketingOptInModalResponse>({
    url: `/api/v7/blocking-modal/marketing-opt-in/`,
    method: 'GET',
    signal,
  });
};

export const getApiMarketingOptInRetrieveQueryKey = () => {
  return [`/api/v7/blocking-modal/marketing-opt-in/`] as const;
};

export const getApiMarketingOptInRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiMarketingOptInRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>> = ({
    signal,
  }) => apiMarketingOptInRetrieve(signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiMarketingOptInRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>
>;
export type ApiMarketingOptInRetrieveQueryError = ErrorType<unknown>;

export function useApiMarketingOptInRetrieve<
  TData = Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof apiMarketingOptInRetrieve>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiMarketingOptInRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
